import { render } from "./Curator.vue?vue&type=template&id=42c59ac4"
import script from "./Curator.vue?vue&type=script&lang=js"
export * from "./Curator.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__